import { Link } from "react-router-dom";
import { Cross, BookOpen, Heart } from "lucide-react";

const beliefs = [
    {
        title: "The Holy Bible",
        verse: "2 Timothy 3:16–17 (ESV)",
        body: "We believe the Holy Bible — both the Old and New Testaments — is the inspired, infallible, and authoritative Word of God. Every Scripture quotation on 2nd Mile Kids is from the English Standard Version (ESV).",
    },
    {
        title: "One God in Three Persons",
        verse: "Matthew 28:19 (ESV)",
        body: "We believe in one God, eternally existing in three Persons: Father, Son, and Holy Spirit — equal in power and glory.",
    },
    {
        title: "Jesus Christ",
        verse: "John 1:14; 1 Corinthians 15:3–4 (ESV)",
        body: "We believe Jesus Christ is fully God and fully man, born of a virgin, lived a sinless life, died on the cross for our sins, was buried, rose bodily on the third day, and is coming again.",
    },
    {
        title: "Salvation by Grace through Faith",
        verse: "Ephesians 2:8–9 (ESV)",
        body: "We believe salvation is the gift of God by grace, received through personal faith in the Lord Jesus Christ — not by works, so that no one can boast.",
    },
    {
        title: "The Holy Spirit",
        verse: "John 14:16–17 (ESV)",
        body: "We believe the Holy Spirit indwells every believer, empowering Christians to live a Christ-honoring life and to love and serve others.",
    },
    {
        title: "The Great Commandment & Commission",
        verse: "Matthew 22:37–39; 28:19–20 (ESV)",
        body: "We are called to love God with all our heart, soul, and mind, to love our neighbor as ourselves, and to make disciples of all nations — going the second mile in love and service.",
    },
];

export default function StatementOfFaith() {
    return (
        <div data-testid="faith-page">
            <section className="border-b-2 border-ink bg-coral/20">
                <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 text-center">
                    <span className="pill bg-white">
                        <Cross className="w-3.5 h-3.5" strokeWidth={2.5} /> What we believe
                    </span>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4">
                        Statement of Faith
                    </h1>
                    <p className="mt-5 text-lg text-ink/80 max-w-2xl mx-auto">
                        2nd Mile Kids is rooted in historic Christian orthodoxy. Every lesson, story, and activity flows from
                        these convictions. Our prayer is that children come to know and love the Lord Jesus Christ.
                    </p>
                </div>
            </section>

            <section className="max-w-4xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-2 gap-6">
                {beliefs.map((b, i) => (
                    <article key={i} className="card-sticker bg-white p-6" data-testid={`belief-${i}`}>
                        <div className="flex items-center gap-2 mb-3">
                            <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-sun border-2 border-ink shrink-0">
                                <BookOpen className="w-5 h-5 text-ink" strokeWidth={2.5} />
                            </span>
                            <h2 className="font-heading text-xl font-bold">{b.title}</h2>
                        </div>
                        <p className="text-sm text-coral font-bold uppercase tracking-widest">{b.verse}</p>
                        <p className="mt-2 leading-relaxed">{b.body}</p>
                    </article>
                ))}
            </section>

            <section className="max-w-3xl mx-auto px-5 sm:px-8 py-12 text-center">
                <Heart className="w-12 h-12 mx-auto text-coral" strokeWidth={2.5} />
                <p className="mt-4 font-accent text-3xl text-coral">
                    "For God so loved the world..."
                </p>
                <p className="text-lg text-ink/80 mt-2">— John 3:16 (ESV)</p>
                <Link to="/lessons" className="btn-sticker bg-sun text-ink mt-6 inline-flex" data-testid="faith-cta">
                    Read today's lesson
                </Link>
            </section>
        </div>
    );
}
